import ChangeCOEModal from "./ChangeCOEModal";

export default ChangeCOEModal;